  import {
    ApolloClient,
    InMemoryCache,
    defaultDataIdFromObject,
    NormalizedCacheObject,
    from,
    HttpLink,
  } from "@apollo/client";
  import { getEnvConfig } from "../config/config";


  const cache = new InMemoryCache({
    typePolicies: { },
    dataIdFromObject: (o) => {
      switch (o.__typename) {
        default:
          return defaultDataIdFromObject(o);
      }
    },
  });

  export const createClient = () => {
      
    const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
      link: from([
        new HttpLink({
          uri: getEnvConfig().PUBLIC_SEARCH_teamsAPI
        }),
      ]),
      cache
    });

    return client;

  };

  export default createClient;
  